const Printers = {
  modes: [
    { id: 1, name: 'Local' },
    { id: 3, name: 'Internet' },
  ],
};

export default Printers;
